import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PlatformBadge } from "@/components/Badges";
import { toast } from "sonner";
import { Shield, Save } from "lucide-react";

const FIELDS = [
  ["caption_limit", "Zeichenlimit Caption"],
  ["max_file_mb", "Max. Dateigröße (MB)"],
  ["max_video_sec", "Max. Videolänge (Sek.)"],
  ["hashtag_limit", "Max. Hashtags"],
];

export default function Regeln() {
  const { can } = useAuth();
  const [rules, setRules] = useState([]);
  const [edit, setEdit] = useState({});

  const load = () => api.get("/rules").then(({ data }) => { setRules(data); const e = {}; data.forEach((r) => e[r.platform] = { ...r }); setEdit(e); });
  useEffect(() => { load(); }, []);

  const save = async (platform) => {
    const r = edit[platform];
    try {
      await api.patch(`/rules/${platform}`, {
        caption_limit: Number(r.caption_limit), max_file_mb: Number(r.max_file_mb),
        max_video_sec: Number(r.max_video_sec), hashtag_limit: Number(r.hashtag_limit),
      });
      toast.success(`${platform}-Regel gespeichert (neue Version)`);
      load();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div>
      <PageHeader overline="Plattform-Regelwerk" title="Plattform-Regeln" subtitle="Formate, Limits & Regeln pro Plattform. Versioniert, da Plattformen sich ändern. Diese Regeln fließen in die Import-Prüfung ein." />
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {rules.map((r) => (
          <Card key={r.platform} data-testid={`rule-card-${r.platform}`} className="p-5 rounded-md border-slate-200 shadow-none">
            <div className="flex items-center justify-between mb-3">
              <PlatformBadge platform={r.platform} />
              <span className="text-[11px] font-mono text-slate-400">v{r.version}</span>
            </div>
            <div className="text-xs text-slate-500 mb-3">Erlaubte Formate: <span className="font-mono text-slate-700">{(r.allowed_formats || []).join(", ")}</span></div>
            <div className="space-y-2">
              {FIELDS.map(([k, l]) => (
                <div key={k} className="flex items-center justify-between gap-2">
                  <span className="text-xs text-slate-600">{l}</span>
                  <Input type="number" data-testid={`rule-${r.platform}-${k}`} value={edit[r.platform]?.[k] ?? ""} disabled={!can("admin")}
                    onChange={(e) => setEdit((s) => ({ ...s, [r.platform]: { ...s[r.platform], [k]: e.target.value } }))}
                    className="h-8 w-28 text-sm font-mono" />
                </div>
              ))}
            </div>
            {can("admin") && <Button size="sm" onClick={() => save(r.platform)} data-testid={`rule-save-${r.platform}`} className="mt-4 w-full rounded-full bg-[#0A0A0A] h-8"><Save size={13} className="mr-1.5" /> Speichern</Button>}
          </Card>
        ))}
      </div>
    </div>
  );
}
